import ENV from 'config/env';
export var getters = {
    getUrl: function (state) { return function (jobId) { return ENV.JOBILLA_API_ROOT + "jobs/" + jobId + "/job-portal-campaigns"; }; },
};
